import { chart } from '@/assets';

export const AboutCompany = () => {
  return (
    <div className='px-8 mt-8 sm:mt-0 mb-8 sm:my-0 sm:p-8 flex'>
      <div className='flex flex-col flex-1'>
        <h2 className='text-lg font-semibold text-start mb-8 text-transform: uppercase text-[indigo]'>
          About the company
        </h2>
        <p className='pr-4'>
          AWAP INVESTORS is a global digital Ecosystem in Real Estate founded by
          OKORIE CALEB EZECHIMA in 2021 in Ebonyi State, Nigeria. The company is
          duly registered with the Corporate Affairs Commission (CAC) and
          licensed by other authorized agencies.
          <br />
          <br />
          AWAP INVESTORS was established due to a driven passion for real estate
          and to help reduce fraud and scams by leveraging technology,
          transparency, and innovation. Our ecosystem is designed to connect
          investors with secure, value-driven opportunities while delivering
          sustainable returns. We bridge the gap between investors, landowners,
          realtors and project developers by providing decentralised access to
          real estate investments. Through our integrated ecosystem, we empower
          individuals and businesses to build wealth, access financing, and
          achieve long-term financial success with confidence.
        </p>
      </div>
      <div className='hidden sm:flex flex-1 justify-end'>
        <img
          alt='chart'
          src={chart}
          className='mt-16 md:mt-0 h-[350px] md:h-[450px]'
        />
      </div>
    </div>
  );
};
